module.exports = __webpack_public_path__ + "img/Rolandskvadet_Chanson_de_Roland.8d4f197c.jpg";